// CARTO basemap tiles. CARTO now requires an API key on raster basemaps;
// without one the tiles render with an "API KEY REQUIRED" watermark.
//
// The key is a browser key (it ships in the bundle via REACT_APP_*), so it
// must be restricted to our domains in the CARTO dashboard rather than kept
// secret. Local: .env.local. Production/preview: Vercel env vars.
const CARTO_API_KEY = process.env.REACT_APP_CARTO_API_KEY;

// Leaflet substitutes {r} with '@2x' on retina displays and '' otherwise.
export const CARTO_TILE_URL = CARTO_API_KEY
  ? `https://basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}{r}.png?key=${CARTO_API_KEY}`
  : // Legacy keyless endpoint — still serves tiles, but watermarked.
    'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';

export const CARTO_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>';

if (!CARTO_API_KEY && process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line no-console
  console.warn('REACT_APP_CARTO_API_KEY is not set — basemap tiles will be watermarked.');
}
